const styles = {
  drawerPaper: {
    width: { xs: '100%', md: '75%', lg: '40%' },
    backgroundColor: 'primary.white',
    display: 'flex',
  },
  boxLineContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 3,
  },
  lineContainer: {
    display: 'flex',
    my: '1em',
  },
  lineLabel: {
    flex: 2,
    fontWeight: 'bold',
  },
  lineValue: {
    flex: 3,
  },
  title: {
    flexGrow: 1,
    ml: '.5em',
  },
  image: {
    objectFit: 'contain',
    maxHeight: '200px',
    overflow: 'hidden',
    width: '100%',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1em',
  },
  fullWidth: {
    width: '100%',
  },
  chip: {
    mr: '1em',
    mt: '1em',
  },
  gridBox: {
    '& .isDevolucao': {
      color: '#FF7F7F',
    },
  },
};

export default styles;
